import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import { Tooltip } from "@msuite/ui/tooltip";
import { cn } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoicePaymentRunListItem } from "@msuite/utils/types";

/** Props Interface */
interface PaymentRunInvoicesCellProps {
	invoices: IncomingInvoicePaymentRunListItem["invoices"];
}

/** The invoices a file paid, each linked; one whose payment was taken back since is struck. */
export function PaymentRunInvoicesCell({ invoices }: PaymentRunInvoicesCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="h-stack gap-2 overflow-hidden">
			{invoices.map((invoice) => (
				<Tooltip
					key={invoice.id}
					label={t("incoming_invoices.payments.payment_reverted")}
					isDisabled={!invoice.isReverted}
				>
					<Link
						href={`/controlling/incoming-invoices/${invoice.id}`}
						className={cn("whitespace-nowrap", invoice.isReverted && "line-through opacity-50")}
					>
						{guardString(invoice.number)}
					</Link>
				</Tooltip>
			))}
		</div>
	);
}
